<div class="control-container" [class.control-shrinked-container]="isShrinked" [class.bottom-text]="bottomText" *ngIf="!textArea">
  <div *ngIf="title" class="centered-row-container-flex-start">
    <label [for]="inputID" class="input-title">{{title}}</label>
    <span *ngIf="required" class="red-10 line-height-80">*</span>
  </div>
  <div class="control {{additionalClass}}" [class.hide-text]="hideText">
    <label [for]="inputID" class="prefix clickable"  *ngIf="prefixFirstIcon||prefixSecondIcon">
      <app-all-icons *ngIf="prefixFirstIcon"
        class="clickable"
        [iconNameAndStyling]="prefixFirstIcon"
        (click)="prefixFirstIconEmitter.emit();$event.stopPropagation()">
      </app-all-icons>
      <app-all-icons *ngIf="prefixSecondIcon"
        class="clickable"
        [iconNameAndStyling]="prefixSecondIcon"
        (click)="prefixSecondIconEmitter.emit();$event.stopPropagation()">
      </app-all-icons>
    </label>
    <label *ngIf="prefixText" class="prefix pref-text font-3 opacity0p64">{{prefixText}}</label>

    <!-- HERE IS YOUR INPUT -->
    <input *ngIf="!dateInput"
           data-qa="app-input-component-regular-input"
           #inputElement class="{{inputClass}}" maxlength="{{maxLength}}"
           [readOnly]="readonly"
           [class.cursor-not-allowed]="disabled"
           [autocomplete]="autocomplete"
           [autofocus]="autofocus" [disabled]="disabled"
           [placeholder]="placeholder" [id]="inputID" [ngModel]="input"  [mask]="separator"
           [thousandSeparator]="thousandSeparator" decimalMarker="." [suffix]="suffix" [prefix]="prefix"
           [type]="type" [allowNegativeNumbers]="allowNegativeNumbers" (blur)="onInputBlur()"
           (focus)="disableAutocompleteOnFocus()" (ngModelChange)="onInputChange($event);"/>

    <input *ngIf="dateInput"
           data-qa="app-input-component-date-input"
           [class.cursor-not-allowed]="disabled"
           [placeholder]="placeholder" [id]="inputID" [ngModel]="input" [min]="minDate"
           [max]="maxDate" [type]="'date'" [disabled]="disabled" (blur)="onInputBlur()"
           (ngModelChange)="inputChange.emit($event); onChange($event)">

    <label *ngIf="suffixText" class="suffix suff-text font-3 opacity0p64">{{suffixText}}</label>

    <label [for]="inputID" class="suffix gap-0.15625"  *ngIf="suffixFirstIcon || suffixSecondIcon || buttonProps || secondButtonProps">
      <div
        *ngIf="suffixFirstIcon"
        class="fixed-pos-tooltip flex"
        (mousedown)="suffixFirstIconEmitter.emit();$event.stopPropagation()"
        (mouseenter)="suffixFirstIconMouseEnterEmitter.emit();$event.stopPropagation()"
        (mouseleave)="suffixFirstIconMouseLeaveEmitter.emit();$event.stopPropagation()">
         <app-all-icons
           data-qa="pc-first-image"
           class="clickable"
           [iconNameAndStyling]="suffixFirstIcon">
         </app-all-icons>
        <div *ngIf="firstSuffixImageTooltip" class="fms-tooltip fixed-pos-tooltip-container">
          <div class="fms-tooltip-body w-max text-[0.78125rem] font-medium" [class.clickable]="pointerOnToolTip"> {{ firstSuffixImageTooltip }}</div>
        </div>
      </div>

      <div
        *ngIf="suffixSecondIcon"
        class="fixed-pos-tooltip flex"
        (mousedown)="suffixSecondIconEmitter.emit();$event.stopPropagation()">
         <app-all-icons
           data-qa="pc-second-image"
           class="clickable"
           [iconNameAndStyling]="suffixSecondIcon">
        </app-all-icons>
        <div *ngIf="secondSuffixImageTooltip" class="fms-tooltip fixed-pos-tooltip-container">
          <div class="fms-tooltip-body w-max text-[0.78125rem] font-medium" [class.clickable]="pointerOnToolTip"> {{ secondSuffixImageTooltip }}</div>
        </div>
      </div>

      <app-button *ngIf="secondButtonProps"
                  data-qa="second-button-svg"
                  [type]="secondButtonProps.type" [size]="secondButtonProps.size"
                  [showIcon]="secondButtonProps.showIcon"
                  [bordersSquaredShape]="secondButtonProps.bordersSquaredShape ? 'full' : ''"
                  [iconName]="secondButtonProps.iconName" [disabled]="secondButtonProps.disabled" [buttonTooltip]="secondButtonProps.buttonTooltip"
                  (buttonClick)="secondButtonClick.emit()">
        {{secondButtonProps.text}}
      </app-button>

      <app-button *ngIf="buttonProps"
        data-qa="button-svg-name"
        [type]="buttonProps.type" [size]="buttonProps.size"
        [showIcon]="buttonProps.showIcon"
        [bordersSquaredShape]="buttonProps.bordersSquaredShape ? 'full' : ''"
        [iconName]="buttonProps.iconName" [disabled]="buttonProps.disabled" [buttonTooltip]="buttonProps.buttonTooltip"
        (buttonClick)="buttonClick.emit()">
        {{buttonProps.text}}
      </app-button>
    </label>

    <div class="logo-for-enter-key centered-row-container" *ngIf="enterKeyText && input">
      <svg width="1.5em" height="1.5em" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.16642 10.3564C8.07072 10.2607 8.02287 10.1331 8.02287 9.98958C8.02287 9.86198 8.07072 9.73438 8.16642 9.63867L9.33081 8.45833H4.19474C3.47697 8.45833 2.9187 7.90006 2.9187 7.18229V5.54167C2.9187 5.27051 3.14201 5.03125 3.42912 5.03125C3.70028 5.03125 3.93953 5.27051 3.93953 5.54167V7.18229C3.93953 7.32585 4.05119 7.4375 4.19474 7.4375H9.33081L8.16642 6.27311C7.95907 6.08171 7.95907 5.74674 8.16642 5.55534C8.35783 5.34798 8.69279 5.34798 8.8842 5.55534L10.9259 7.59701C11.1332 7.78841 11.1332 8.12337 10.9259 8.31478L8.8842 10.3564C8.69279 10.5638 8.35783 10.5638 8.16642 10.3564Z" />
      </svg>
      {{enterKeyText}}
    </div>

    <label [for]="inputID" class="control-bottom">{{bottomText}}</label>
  </div>
</div>
<div class="textarea control-container" *ngIf="textArea"  [class.control-shrinked-container-textarea]="isShrinked">
  <div *ngIf="title" class="centered-row-container-flex-start">
    <label *ngIf="title" [for]="inputID" class="input-title">{{title}}</label>
    <span *ngIf="required" class="red-10">*</span>
  </div>
  <textarea
    data-qa="app-input-textarea"
    class="control textarea-max-height {{additionalClass}} {{inputClass}}"
    maxlength="{{maxLength}}"
    [class.cursor-not-allowed]="disabled"
    [class.no-propagation]="disabled"
    [disabled]="disabled" [ngModel]="input"
    [title]="title"
    [placeholder]="placeholder"
    (blur)="blurEmitter.emit($event.target.value)"
    (ngModelChange)="onInputChange($event)">
  </textarea>
</div>
